import { CommonEnumService } from "../../common/main/services/CommonEnumService"


export enum ELanguageTypes {
  en = "en",
  de = "de"  
}

export class EnumLanguageTypes {

  public static getArrayOfIds(): string[] {
    return CommonEnumService.mapEnumStringToArrayofEnumStrings(ELanguageTypes).map((it) => { return it.value } )
  }

  public static getArrayOfLanguageKeys(): string[] {
    return CommonEnumService.mapEnumStringToArrayofEnumStrings(ELanguageTypes).map((it) => { return "lng_" + it.value })
  }

  // public static getEnumByValue(value: string): ELanguageTypes {
  //   return CommonEnumService.mapEnumStringToArrayofEnumStrings(ELanguageTypes).map((it, idx) => { 
  //     if(it.value == value) return 
  //   )
  // }
}